import React from "react"
import { Link } from "gatsby"
import baumagazin from "assets/b-i-baumagazin-submenu-white.png"
import galabau from "assets/b-i-galabau-submenu-white.png"
import umweltbau from "assets/b-i-umweltbau-submenu-white.png"

export const BfzLogo = ({ link, title, page }) => {
  const all_logos = {
    baumagazin: baumagazin,
    galabau: galabau,
    umweltbau: umweltbau,
  }
  return (
    <Link className="my-auto" to={link}>
      <img
        src={all_logos[page]}
        alt={title}
        title={title}
        style={{
          maxWidth: 145,
          maxHeight: 35,
        }}
      />
    </Link>
  )
}
